import DataTable from './dataTable'

/******************************************************************************
 *  Leads
 *****************************************************************************/

/**
 * @type {Lead}
 */
export default class Lead extends DataTable {

    constructor () {
        super('/leads', '/leads')
        this.columns = [
            this.prototypes.column('lead_id', 'leads.id', true, true),
            this.prototypes.column('lead_name', 'leads.name', true, true),
            this.prototypes.column('lead_type', 'leads.type', true, true),
            this.prototypes.column('users_next_name', 'users_next_name', false, false),
            this.prototypes.column('users_total', 'users_total', false, true),
            this.prototypes.column('lead_leads', 'leads.leads', false, true),
            this.prototypes.column('lead_created_at', 'leads.created_at', false, true),
			this.prototypes.column('lead_updated_at', 'leads.updated_at', false, true),
			this.prototypes.column('customer_created_at', 'customer_created_at', false, true),
            this.prototypes.column('customer_name', 'customer_name', false, false),
            this.prototypes.column('lead_status', 'leads.status', true, true),
            this.prototypes.column('product_name', 'p.name', false, true),
            this.prototypes.column('10', '', false, false)
        ]
    }
}